export const getWeek = (no) => {
    console.log("no123" ,no)
    let number = Number(no);
    const obj = {
        1:"Monday",
        2:"Tuesday",
        3:"Wednesday",
        4:"Thursday",
        5:"Friday",
        6:"Saturday",
        0:"Sunday",
    }
    return obj[number];
}